import greiffModernSf from './GreiffModernSf.jpg';

export const greiffModernSfImpressions = {
    greiffModernSf,
};
